import { render } from "./PurchaseDestinations.vue?vue&type=template&id=e570c7bc"
import script from "./PurchaseDestinations.vue?vue&type=script&lang=js"
export * from "./PurchaseDestinations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__